import React from 'react';

const ApiImage = ({ path, alt = '', className = '', style = {} }) => {
  if (!path) return null;

  const src = `${process.env.REACT_APP_API_URL}/api/images?path=${encodeURIComponent(path)}`;

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
    />
  );
};

export default ApiImage;
